import { render, staticRenderFns } from "./DemoLogoutBtn.vue?vue&type=template&id=020c38f4&scoped=true&"
import script from "./DemoLogoutBtn.vue?vue&type=script&lang=js&"
export * from "./DemoLogoutBtn.vue?vue&type=script&lang=js&"
import style0 from "./DemoLogoutBtn.vue?vue&type=style&index=0&id=020c38f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020c38f4",
  null
  
)

export default component.exports